<app-promo-sticky *ngIf="lottoId > 0 && !showNavBar">
  <ng-container *ngFor="let item of ('assets' | translate)">
    <img [attr.src]="item.clock" width="20" class="inline-block relative top-5 margin-right-5" alt="" />
  </ng-container>
  <span class="inline-block margin-right-5">{{'stickyPromo.a' | translate }}</span>
  <strong class="inline-block weight-600 margin-right-5">{{'stickyPromo.b' | translate }}</strong>
  <span class="inline-block">{{'stickyPromo.c' | translate }}</span>
</app-promo-sticky>  
<header class="padding-top-bottom-15 bg-light-2" *ngIf="!showNavBar">
  <div class="content-wrap flex row wrap y-items-center space-between full-height">
    <h1 class="logo-title absolute top-0 left-0 block">
      <ng-container *ngIf="sys === 'wt'">
        <ng-container *ngIf="('lang' | translate) === 'en'"> Wintrillions.com </ng-container>
        <ng-container *ngIf="('lang' | translate) === 'es'"> Trillonario.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> Trilhardario.com </ng-container>
      </ng-container>
      <ng-container *ngIf="sys === 'ltk'">
        <ng-container *ngIf="('lang' | translate) != 'pt'"> Lottokings.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> LottoSena.com </ng-container>
      </ng-container>
    </h1>
    <ng-container *ngIf="sys === 'wt'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/en/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/es/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
      </ng-container>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <ng-container *ngIf="('lang' | translate) != 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/default/logo.png'" alt="logo" />
      </ng-container>
      <ng-container *ngIf="('lang' | translate)  === 'pt'">
        <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
      </ng-container>
    </ng-container>

    <h4 class="slogan">
      <ng-container *ngIf="('lang'| translate)  === 'en'"> More loteries, more chances, more fun </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es'"> Más loterías, más chances, más diversión </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'pt'"> Mais loterias, mais oportunidades, mais diversão! </ng-container>
    </h4>
  </div>
</header>
